import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import PageWrapper from 'Pages/@PageWrapper'
import CustomMappingPageContent from './Content'
import { USER_ROUTES } from '../../../@constants'
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from './VirtualTour'
import MappingDemoData from './VirtualTour/DemoData'
import { isTourDemoActive } from '@signals/app'
import { MAPPING_TYPE } from 'Pages/User/CustomMapping/@constants'
import { selectedMappingTab } from 'Pages/User/CustomMapping/@signals'


export default function CustomMappingPage() {
	const [tourActive, setTourActive] = useState(false)

	return <PageWrapper
		head={`DS Rentacar | ${USER_ROUTES.CUSTOM_MAPPING_SUBTITLE}`}
		title={USER_ROUTES.TITLE}
		subtitle={USER_ROUTES.CUSTOM_MAPPING_SUBTITLE}
		isEmpty={false}
		actions={<VirtualTourButton onClick={() => { selectedMappingTab.value = MAPPING_TYPE.ACRISS; setTourActive(true); isTourDemoActive.value = true }} />}
	>
		<CustomMappingPageContent/>
		{tourActive && <MappingDemoData />}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => { setTourActive(false); isTourDemoActive.value = false }} />,
			document.body
		)}
	</PageWrapper>
}